export function stickyHeader() {
    const header = document.querySelector(".header");
    function stickyHeaderOnScroll() {
        const currentScroll = window.scrollY;
        if (currentScroll < 1) {
            header.classList.remove("sticky");
        }

        if (currentScroll > 0) {
            header.classList.add("sticky");
        } else {
            header.classList.remove("sticky");
        }
    }


    window.addEventListener("load", () => {
        stickyHeaderOnScroll();
    });

    window.addEventListener("scroll", stickyHeaderOnScroll);

}


// WEBPACK FOOTER //
// ./assets/js/modules/stickyHeader.js